import { Directive, ElementRef, Input, OnInit } from "@angular/core";
import { AuthService } from "../../@auth/auth.service";
import { AuthSessionDto, USER_PERMISSION_POLICY } from "../../app.models";
import { CluPermissionService } from "./clu-permission.service";

@Directive({
    selector: '[cluPermission]'
})
export class CluPermissionDirective implements OnInit {
    @Input('cluPermission') permissions: string[];

    constructor(
        private elementRef: ElementRef,
        private cluPermissionService: CluPermissionService,
    ) {
    }

    ngOnInit(): void {
        const hasPermission = this.cluPermissionService.hasPermission(this.permissions);
        if (!hasPermission) {
            this.elementRef.nativeElement.style.display = 'none';
        }
    }
}

@Directive({
    standalone: true,
    selector: '[cluHasVisaPermission]'
})
export class CluHasVisaPermissionDirective implements OnInit {
    @Input('cluHasVisaPermission') permissions: string[];

    constructor(
        private elementRef: ElementRef,
        private cluPermissionService: CluPermissionService,
    ) {
    }

    ngOnInit(): void {
        const hasVisaPermission = this.cluPermissionService.hasVisaPermission(this.permissions);
        if (!hasVisaPermission) {
            this.elementRef.nativeElement.style.display = 'none';
        }
    }
}